import merge from 'lodash/merge'
import es from '../es'
import talentPool from './talent-pool.json'
import currencyMask from './currency-mask.json'
import homePage from './home-page.json'
import productos from './productos.json'
import companyProfile from './company-profile.json'
import avisoPublicacion from './aviso-publicacion.json'
import avisoPublicacionProductos from './aviso-publicacion-productos.json'
import ecommerce from './ecommerce.json'
import footer from './footer.json'
import signUp from './sign-up.json'

const pe = {
  ...es,
  currency: 'S/.',
  talentPool: merge({}, es.talentPool, talentPool),
  currencyMask,
  homePage: merge({}, es.homePage, homePage),
  productos: merge({}, es.productos, productos),
  companyProfile: merge({}, es.companyProfile, companyProfile),
  avisoPublicacion: merge({}, es.avisoPublicacion, avisoPublicacion),
  avisoPublicacionProductos: merge({}, es.avisoPublicacionProductos, avisoPublicacionProductos),
  ecommerce: merge({}, es.ecommerce, ecommerce),
  footer: merge({}, es.footer, footer),
  signUp: merge({}, es.signUp, signUp),
}

export default pe
